import React from 'react';
import dynamic from 'next/dynamic';
import Layout from './Layout';
const LayoutWithStickyTimer = dynamic(() => import(/* webpackChunkName: "blazePbLayoutWithStickyTimer" */'./LayoutWithStickyTimer'));
const LayoutFactory = props => {
  const {
    sticky,
    stickyTimer
  } = props;
  if (sticky && stickyTimer) return /*#__PURE__*/React.createElement(LayoutWithStickyTimer, props);
  return /*#__PURE__*/React.createElement(Layout, props);
};
export default LayoutFactory;
//# sourceMappingURL=LayoutFactory.js.map